import { writable } from 'svelte/store';
export const UnmatchedStaffs = writable([]);
export const UnmatchedPupils = writable([]);
export const UnmatchedUsers = writable([]);
export const ProviderName = writable("");
export const IsAuthConfigValid =writable();
